// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cesium-infoBox {
  display: block;
  position: absolute;
  top: 50px;
  right: 0;
  width: 40%;
  max-width: 480px;
  background: rgba(38, 38, 38, 0.95);
  color: #edffff;
  border: 1px solid #444;
  border-right: none;
  border-top-left-radius: 7px;
  border-bottom-left-radius: 7px;
  box-shadow: 0 0 10px 1px #000;
  transform: translate(100%, 0);
  visibility: hidden;
  opacity: 0;
  transition:
    visibility 0s 0.2s,
    opacity 0.2s ease-in,
    transform 0.2s ease-in;
}

.cesium-infoBox-visible {
  transform: translate(0, 0);
  visibility: visible;
  opacity: 1;
  transition:
    opacity 0.2s ease-out,
    transform 0.2s ease-out;
}

.cesium-infoBox-title {
  display: block;
  height: 20px;
  padding: 5px 30px 5px 25px;
  background: rgba(84, 84, 84, 1);
  border-top-left-radius: 7px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: content-box;
}

.cesium-infoBox-bodyless .cesium-infoBox-title {
  border-bottom-left-radius: 7px;
}

button.cesium-infoBox-camera {
  display: block;
  position: absolute;
  top: 4px;
  left: 4px;
  width: 22px;
  height: 22px;
  background: transparent;
  border-color: transparent;
  border-radius: 3px;
  padding: 0 5px;
  margin: 0;
}

button.cesium-infoBox-close {
  display: block;
  position: absolute;
  top: 5px;
  right: 5px;
  height: 20px;
  background: transparent;
  border: none;
  border-radius: 2px;
  font-weight: bold;
  font-size: 16px;
  padding: 0 5px;
  margin: 0;
  color: #edffff;
}

button.cesium-infoBox-close:focus {
  background: rgba(238, 136, 0, 0.44);
  outline: none;
}

button.cesium-infoBox-close:hover {
  background: #888;
  color: #000;
}

button.cesium-infoBox-close:active {
  background: #a00;
  color: #000;
}

.cesium-infoBox-bodyless .cesium-infoBox-iframe {
  display: none;
}

.cesium-infoBox-iframe {
  border: none;
  width: 100%; /* Fallback */
  width: calc(100% - 2px);
}
`, "",{"version":3,"sources":["webpack://./cesium/Source/Widgets/InfoBox/InfoBox.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;EAC3B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV;;;0BAGwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,UAAU;EACV;;2BAEyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,0BAA0B;EAC1B,+BAA+B;EAC/B,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW,EAAE,aAAa;EAC1B,uBAAuB;AACzB","sourcesContent":[".cesium-infoBox {\n  display: block;\n  position: absolute;\n  top: 50px;\n  right: 0;\n  width: 40%;\n  max-width: 480px;\n  background: rgba(38, 38, 38, 0.95);\n  color: #edffff;\n  border: 1px solid #444;\n  border-right: none;\n  border-top-left-radius: 7px;\n  border-bottom-left-radius: 7px;\n  box-shadow: 0 0 10px 1px #000;\n  transform: translate(100%, 0);\n  visibility: hidden;\n  opacity: 0;\n  transition:\n    visibility 0s 0.2s,\n    opacity 0.2s ease-in,\n    transform 0.2s ease-in;\n}\n\n.cesium-infoBox-visible {\n  transform: translate(0, 0);\n  visibility: visible;\n  opacity: 1;\n  transition:\n    opacity 0.2s ease-out,\n    transform 0.2s ease-out;\n}\n\n.cesium-infoBox-title {\n  display: block;\n  height: 20px;\n  padding: 5px 30px 5px 25px;\n  background: rgba(84, 84, 84, 1);\n  border-top-left-radius: 7px;\n  text-align: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  box-sizing: content-box;\n}\n\n.cesium-infoBox-bodyless .cesium-infoBox-title {\n  border-bottom-left-radius: 7px;\n}\n\nbutton.cesium-infoBox-camera {\n  display: block;\n  position: absolute;\n  top: 4px;\n  left: 4px;\n  width: 22px;\n  height: 22px;\n  background: transparent;\n  border-color: transparent;\n  border-radius: 3px;\n  padding: 0 5px;\n  margin: 0;\n}\n\nbutton.cesium-infoBox-close {\n  display: block;\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  height: 20px;\n  background: transparent;\n  border: none;\n  border-radius: 2px;\n  font-weight: bold;\n  font-size: 16px;\n  padding: 0 5px;\n  margin: 0;\n  color: #edffff;\n}\n\nbutton.cesium-infoBox-close:focus {\n  background: rgba(238, 136, 0, 0.44);\n  outline: none;\n}\n\nbutton.cesium-infoBox-close:hover {\n  background: #888;\n  color: #000;\n}\n\nbutton.cesium-infoBox-close:active {\n  background: #a00;\n  color: #000;\n}\n\n.cesium-infoBox-bodyless .cesium-infoBox-iframe {\n  display: none;\n}\n\n.cesium-infoBox-iframe {\n  border: none;\n  width: 100%; /* Fallback */\n  width: calc(100% - 2px);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
